export const PROFILE_VERSION = 1;

export const PROFILE_BIO_MAX = 500;
export const PROFILE_CITY_MAX = 80;
export const PROFILE_STATE_MAX = 80;
export const PROFILE_COUNTRY_MAX = 80;
export const PROFILE_CONTACT_EMAIL_MAX = 120;
export const PROFILE_PHONE_NATIONAL_MAX = 15;
export const PROFILE_FAVORITE_SHOT_MAX = 80;
export const PROFILE_PHOTO_REF_MAX = 2048;
export const PROFILE_COVER_PHOTO_REF_MAX = 512;
export const PROFILE_GENDER_MAX = 32;
export const PROFILE_DATE_OF_BIRTH_MAX = 16;
export const PROFILE_CLUB_MAX = 80;
export const PROFILE_PREFERRED_EVENTS_MAX = 8;
export const PROFILE_PREFERRED_EVENT_LEN = 40;

/** @typedef {'Left' | 'Right' | ''} PreferredHand */
/** @typedef {'Singles' | 'Doubles' | 'Mixed' | 'All' | ''} PlayingCategory */

export const PREFERRED_HANDS = /** @type {const} */ (["", "Left", "Right"]);
export const PLAYING_CATEGORIES = /** @type {const} */ (["", "Singles", "Doubles", "Mixed", "All"]);

/** Profile gender choices (analytics-friendly stable values). */
export const PROFILE_GENDERS = /** @type {const} */ ([
  "",
  "Female",
  "Male",
  "Non-binary",
  "Prefer not to say",
]);

/** Local blob storage marker stored on Firestore `profilePhoto` field. */
export const PROFILE_PHOTO_LOCAL_MARKER = "local";

export const PROFILE_VISIBILITY = /** @type {const} */ ({
  PUBLIC: "public",
  PRIVATE: "private",
});
